<template>
    <Loader v-if="loading"/>
    <div class="content" v-else>
        <h2 class="text-center">How many customers getting boxes from us</h2>

        <div class="row" style="display: flex">
            <div class="col">
                <h3 class="text-center">My speed this week</h3>
                <weekly-speed-chart :data="getSpeedChartData"/>
            </div>
            <div class="col">
                <h3 class="text-center">Success built on teamwork!</h3>
                <team-work-chart :data="getTeamWorkChartData" :goal="getTeamWorkGoalData" />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import WeeklySpeedChart from '@/components/WeeklySpeedChart.vue'
import TeamWorkChart from '@/components/TeamWorkChart.vue'
import moment from 'moment'

export default {
  components: { WeeklySpeedChart, TeamWorkChart },

  data: () => ({
    speedChartData: [],
    teamWorkChartData: [],
    loading: false,
    selected: 'last_month',
    dateRangeOptions: [
      { text: 'Last 30 days', value: 'last_month' },
      { text: 'Last week', value: 'last_week' },
      { text: 'Last day', value: 'last_day' }
    ]
  }),

  computed: {
    getSpeedChartData () {
      return this.speedChartData
    },

    getTeamWorkChartData () {
      return this.teamWorkChartData
    },

    getTeamWorkGoalData () {
      return this.teamWorkGoalData
    },

    getRatingChartData () {
      return this.ratingChartData
    },

    getHappinessChartData () {
      return this.happinessChartData
    },

    getTotalChartData () {
      return this.totalChartData
    }
  },
  methods: {
    load (range = null) {
      const params = range ? '?date_range=' + range : ''

      Vue.api.get('/stylist/dashboard' + params, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => {
          this.prepareData(data)
        }
      })
    },

    prepareData (data) {
      if (data.week) {
        this.prepareSpeedChartData(data)
      }
      if (data.teamwork) {
        this.prepareTeamWorkChartData(data)
      }
    },

    prepareSpeedChartData (data) {
      const speedChartData = data.week
      const weekDaysRange = [1, 2, 3, 4, 5, 6, 7].map(function (date) {
        return moment().startOf('isoWeek').weekday(date).date()
      })

      const arr = []; let sum

      weekDaysRange.map(function (v) {
        if (!(v in speedChartData)) {
          arr.push(0)
        } else {
          arr.push(speedChartData[v])
        }
      })
      this.speedChartData = arr.map(function (elem) {
        if (elem === 0) {
          return 0
        }
        return elem
      })

      const totalWeek = Object.values(this.speedChartData).reduce((sum, current) => sum + current)
      this.speedChartData.push(totalWeek)
    },

    prepareTeamWorkChartData (data) {
      const teamWorkChartData = data.teamwork
      const weekDaysRange = [1, 2, 3, 4, 5, 6, 7].map(function (date) {
        return moment().startOf('isoWeek').weekday(date).date()
      })

      const arr = []; let sum

      weekDaysRange.map(function (v) {
        if (!(v in teamWorkChartData)) {
          arr.push(0)
        } else {
          arr.push(teamWorkChartData[v])
        }
      })

      this.teamWorkChartData = arr.map(function (elem) {
        if (elem === 0) {
          return 0
        }
        return sum = (sum || 0) + elem
      })
    },

    roundPercentage (data) {
      const target = 100
      const off = target - _.reduce(data, function (acc, x) { return acc + Math.round(x) }, 0)
      return _.chain(data).map(function (x, i) { return Math.round(x) + (off > i) - (i >= (data.length + off)) }).value()
    }
  },
  created () {
    this.load()
  },
  watch: {
    selected: function (val, oldVal) {
      this.load(val)
    }
  }
}
</script>
<style scoped lang="less">

    .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .col {
        flex-direction: column;
    }

    .range-row {
        flex-direction: row-reverse;
    }

    .satisfied-row {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .col {
            &:nth-of-type(1) {
                flex: 0 0 30%;
            }
            &:nth-of-type(2) {
                flex: 0 0 30%;
            }

            &:nth-of-type(3) {
                flex: 0 0 30%;
            }
        }
    }
</style>
